import styled from 'styled-components';
import { getSpacing, zIndex } from 'stylesheet';
var ButtonsContainer = styled.div.withConfig({
  displayName: "AffiliationBlockTypeSelectionstyle__ButtonsContainer",
  componentId: "sc-k82ayn-0"
})(["position:relative;z-index:", ";display:flex;flex-direction:column;flex-wrap:wrap;row-gap:", ";margin:", " ", " 0;"], zIndex["default"], getSpacing(1), getSpacing(2), getSpacing(1));
export { ButtonsContainer };